import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { BUGSNAG_CONFIG } from '../common/config';

let user = localStorage.getItem('OPTIMIZE_USER_DATA');

let callerId = null;
let callerName = null;
user = JSON.parse(user);
if (user !== null) {
  callerId = user.id;
  callerName = user.userId;
}

export default Bugsnag.start({
  ...BUGSNAG_CONFIG,
  plugins: [new BugsnagPluginReact()],
  user: {
    id: callerId,
    name: callerName
  }
});
